import { PawPrint } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-border/50 py-10 md:py-14">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <PawPrint className="w-4 h-4 text-primary-foreground" strokeWidth={2} />
            </div>
            <span className="font-bold text-foreground tracking-tight">
              Clínica Veterinaria Demo
            </span>
          </div>

          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <a href="#servicios" className="hover:text-foreground transition-colors">
              Servicios
            </a>
            <a href="#como-funciona" className="hover:text-foreground transition-colors">
              Cómo funciona
            </a>
            <a href="#faq" className="hover:text-foreground transition-colors">
              FAQ
            </a>
          </div>

          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} Demo. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
